export default __webpack_public_path__ + "static/media/slot-cat.da89b525.webp";